/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ReportBuilderImport } from './routes/report-builder'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const ReportBuilderRoute = ReportBuilderImport.update({
  path: '/report-builder',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/report-builder': {
      id: '/report-builder'
      path: '/report-builder'
      fullPath: '/report-builder'
      preLoaderRoute: typeof ReportBuilderImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/report-builder': typeof ReportBuilderRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/report-builder': typeof ReportBuilderRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/report-builder': typeof ReportBuilderRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/report-builder'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/report-builder'
  id: '__root__' | '/' | '/report-builder'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ReportBuilderRoute: typeof ReportBuilderRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ReportBuilderRoute: ReportBuilderRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/report-builder"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/report-builder": {
      "filePath": "report-builder.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
